import omit from 'lodash/omit';

export const getMenuCategory = async (id, menuId) => {
  if (['-default', '-soft', '-hard', '-food', '-combo', '-filler', '-pagebreak', '-freetext'].includes(id)) {
    return await window.axios
      .request({
        url: '/menu-categories/' + id,
        method: 'post',
        headers: {
          'Content-Type': 'application/vnd.api+json',
        },
        data: { menuId },
      })
      .then((response) => {
        return response.data.data;
      });
  }
  return await window.axios.get('/menu-categories/' + id).then(({ data }) => {
    return data;
  });
};

export const getMenuCategories = async (id) => {
  return await window.axios
    .get('/menu-categories?filter[menu_id]=' + id + '&include=menuItems,menuItems.ingredients')
    .then(({ status, data }) => {
      if (status === 200) {
        return data;
      }
    });
};

export const storeMenuCategory = async (category) => {
  const method = category.id ? 'patch' : 'post';

  return await window.axios
    .request({
      url: '/menu-categories/' + (category.id ?? '') + '?include=menuItems,menuItems.ingredients',
      method,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      data: { data: omit(category, category.id ? [] : ['id']) },
      transformRequest: [(data) => JSON.stringify(data)],
    })
    .then((response) => {
      return response.data.data;
    });
};

export const deleteMenuCategory = async (categoryId, moreIds) => {
  return await window.axios
    .delete(`/menu-categories/${categoryId}`, {
      data: {
        moreIds,
      },
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((data) => {
      return data.data;
    });
};
